import { Controller } from 'stimulus';
import 'cookieconsent/build/cookieconsent.min.css';

require('cookieconsent');

export default class extends Controller {
  connect() {
    const message = this.data.get('message');
    const dismiss = this.data.get('dismiss');
    const link = this.data.get('link');
    const href = this.data.get('href') || '/cookie-policy';

    window.cookieconsent.initialise(
      {
        palette: {
          popup: {
            background: '#335eea',
            text: '#ffffff',
          },
          button: {
            background: '#ffffff',
            text: '#335eea',
          },
        },
        position: 'bottom-right',
        theme: 'classic',
        content: {
          message,
          dismiss,
          link,
          href,
        },
        dismissOnTimeout: 60000,
      },
    );
  }
}
